export default __webpack_public_path__ + "3ec4529588af87a56ed4f06e5f3673bc.jpeg";